























































































































import { Component, Watch, Vue, Prop } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { patrolManagementServe } from '@/api/installServer';
import PatrolTaskMap from './task-map.vue';
import TaskAbnormalDialog from '@/views/patrolManagement/patrolTask/unit/taskAbnormalDialog.vue';

@Component({
  components: {
    TaskAbnormalDialog,
    PatrolTaskMap,
  },
})
export default class TaskInfo extends Vue {
  @Prop() row!: any; // 从父组件接受过来一行的数据

  private form: any = {
    loading: false,
    name: '',
    time: '',
    startTime: '',
    endTime: '',
    lineId: '',
    lineName: '',
    taskRiskAssessId: '',
    taskRiskAssessVersion: 0,
    taskRiskAssessName: '',
    staffList: [],
    pointList: [],
    finishRate: 0,
    finishNum: 0,
    verifyWeedNum: 0,
    unFinishNum: 0,
    allNum: 0,
    statusCode: 2,
  };

  private pointList: any = [];
  private reasonApplication: any = '';
  private visible = false;
  private replaceTime: any = '';
  private id: any = '';
  private isAllow = true;

  created() {
    this.getTaskData();
  }
  /**
   * 【接口】获取巡检任务详情
   * @param id {String}
   */
  async getTaskData() {
    this.form.loading = true;
    patrolManagementServe
      .getPatrolTaskInfoData(this.row.id)
      .then((res: any) => {
        if (res.code === '200') {
          console.log(res.data);
          this.form = res.data;
          this.form.pointList.forEach((item: any) => {
            this.$set(item, 'replaceVisible', false);
          });
          if (this.form.statusCode === 2 || this.form.statusCode === 1) {
            this.isAllow = false;
          }
        } else {
          this.$message.warning(res.msg);
        }
        this.form.loading = false;
      })
      .catch((error: any) => {
        this.$message.error('网络异常，请稍后重试。');
        this.form.loading = false;
      });
    // try {
    //   const res: any = await patrolManagementServe.getPatrolTaskInfoData(id);
    //
    //   if (res.code !== '200') {
    //
    //     throw new Error();
    //   }
    //
    //   this.taskData = res.data;
    //   this.taskData.pointList.forEach((item: any) => {
    //     this.$set(item, 'replaceVisible', false);
    //   });
    //   setTimeout(() => {
    //     this.assignDataToForm(res.data);
    //   }, 20);
    //
    //   return res;
    // } catch (e) {
    //   throw new Error();
    // }
  }

  verifyWeedCancel() {
    this.reasonApplication = '';
    this.visible = false;
  }
  /**
   *【按钮】申请剔除确定按钮
   * @Params
   * @return
   **/
  addVerifyWeedClickBtn() {
    if (this.reasonApplication === '' || this.reasonApplication === null) {
      this.$message.warning('申请理由不允许为空');
    } else {
      this.addVerifyWeed();
      this.visible = false;
    }
  }
  handleSelectionChange(val: any) {
    this.pointList = val;
  }
  /**
   *【接口】提交剔除申请
   * @Params
   * @return
   **/
  addVerifyWeed() {
    const temp_pointIds: any = this.pointList.map((item: any) => item.id);
    patrolManagementServe
      .addPatrolVerify({
        taskId: this.form.id,
        taskPointIds: temp_pointIds,
        reasonApplication: this.reasonApplication,
      })
      .then((res: any) => {
        if (res.code === '201') {
          this.$message.success('待领导审核是否剔除。');
          this.getTaskData();
          this.verifyWeedCancel();
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch((error: any) => {
        this.$message.error('网络错误！');
      });
  }
  /**
   * 【表单】表单赋值
   * @param data {any} 覆盖表单数据
   */
  assignDataToForm(data: any) {
    this.form = {
      ...this.form,
      ...{
        name: data.name,
        lineId: data.lineId,
        lineName: data.lineName,
        time: data.startTime && [data.startTime, data.endTime],
        startTime: data.startTime,
        endTime: data.endTime,
        staffList: data.staffList,
        finishRate: data.finishRate,
        finishNum: data.finishNum,
        verifyWeedNum: data.verifyWeedNum,
        unFinishNum: data.unFinishNum,
        allNum: data.allNum,
        statusCode: data.statusCode,
        taskRiskAssessId: data.taskRiskAssessId,
        taskRiskAssessVersion: data.taskRiskAssessVersion,
        taskRiskAssessName: data.taskRiskAssessName,
      },
    };
  }

  handleBtnClick() {
    const PatrolTaskMapComponent: any = this.$refs['PatrolTaskMap'];
    PatrolTaskMapComponent.showAddDialog(this.id);
  }

  openWarningData(data: any) {
    const taskAbnormalDialogComponent: any = this.$refs['taskAbnormalDialog'];
    taskAbnormalDialogComponent.showAddDialog(data);
  }

  /**
   * 【按钮】返回按钮
   * @Params
   * @return
   **/
  handleCancelBtnClick() {
    this.$emit('on-response');
  }

  handleTableBtnClick(data: any) {
    this.form.pointList.forEach((item: any) => {
      item.replaceVisible = false;
    });
    data.replaceVisible = true;
  }
  cancelFinishedPoint(data: any) {
    data.replaceVisible = false;
    this.replaceTime = '';
  }

  async handleFinishedPoint(id: any, data: any) {
    patrolManagementServe
      .finishedPoint([{ id: id, finishTime: this.replaceTime }])
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('补卡成功');
          data.replaceVisible = false;
          this.replaceTime = '';
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch((error: any) => {
        this.$message.error('请检查网络并在规定时间内完成补卡');
      });
  }
}
